<div fxLayout="column"
     fxLayoutAlign="center center"
     fxLayoutGap="16px"
     class="loading-screen">
    <mat-spinner class="circle"
                 color="primary"></mat-spinner>
    <div>Loading</div>
</div>
